import React from 'react';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';

export const PlansBasicInfoComponent = ({

  selectedPlans, onInnerBasicFormChange, PolicyOwnerType, AccountTypes, Accounts,AccountTypesLoader
}: any) => (

  <>
    <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-3 gap-3'>
          <InputContainer
            label="Name"
            name="Name"
            onValueChange={(event: any) => {
              onInnerBasicFormChange(
                event.target.value,
                'Name'
              )
            }}
            type="text"
            value={selectedPlans?.Name}
          />

          <InputContainer
            label="Description"
            name="Description"
            onValueChange={(event: any) => {
              onInnerBasicFormChange(
                event.target.value,
                'Description'
              )
            }}
            type="text"
            value={selectedPlans?.Description}
          />
          <InputContainer
            label="Display Order"
            name="DisplayOrder"
            onValueChange={(event: any) => {
              onInnerBasicFormChange(
                event.target.value,
                'DisplayOrder'
              )
            }}
            type="number"
            value={selectedPlans?.DisplayOrder}
          />

          <InputContainer
            label="Active"
            name="IsActive"
            onValueChange={(event: any) => {
              onInnerBasicFormChange(
                event,
                'IsActive'
              )
            }}
            type="checkbox"
            value={selectedPlans?.IsActive}
          />

          <InputContainer
            label="Level"
            labelField="Text"
            isLoading={PolicyOwnerType}
            list={PolicyOwnerType}
            onValueChange={(event: any) => {
              onInnerBasicFormChange(
                event.target.value,
                'OwnerId'
              );
            }}
            optionName='Choose Level'
            type="select"
            value={selectedPlans?.OwnerId}
            valueField="Value"
          />

          <InputContainer
            label="Account Type"
            labelField="Name"
            isLoading={AccountTypesLoader}
            list={AccountTypes}
            onValueChange={(event: any, newValue: any) => {
              onInnerBasicFormChange(
                event.target.value,
                'AssociatedAccountTypeId',
              );
            }}
            optionName='Choose Account Type'
            type="select"
            value={selectedPlans?.AssociatedAccountTypeId}
            valueField="Id"
          />
          <InputContainer
            label="Account Name"
            labelField="Name"
            isLoading={Accounts}
            list={Accounts}
            onValueChange={(event: any, newValue: any) => {
              onInnerBasicFormChange(
                event.target.value,
                'AssociatedAccountId',
              );
            }}
            optionName='Choose Account Name'
            type="select"
            value={selectedPlans?.AssociatedAccountId}
            valueField="Id"
          />


          <InputContainer
            label="Start Date"
            name="StartDateUtc"
            onValueChange={(event: any) => {
              onInnerBasicFormChange(
                event.target.value,
                'StartDateUtc'
              )
            }}
            type="date"
            value={selectedPlans?.StartDateUtc}
          />
          <InputContainer
            label="End Date"
            name="EndDateUtc"
            onValueChange={(event: any) => {
              onInnerBasicFormChange(
                event.target.value,
                'EndDateUtc'
              )
            }}
            type="date"
            value={selectedPlans?.EndDateUtc}
          />



        </div>
      }
      expandedPanel="BasicInfo"
      headerTitle="Basic Info"
    />
  </>
)

export default PlansBasicInfoComponent;
